import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { ContactModel } from '../model/contactModel.model';
import { StringKeyValue } from '../model/stringKeyValue.model';
@Injectable({
  providedIn: 'root'
})
export class ContactInfoService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/ContactAddress/';
  }

  getContactTypes(): Observable<Array<string>> {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getContactTypes`)).pipe(map((result) => result as Array<string>));
  }

  getContactTypesForMultiContact(parameterModel: string, moduleName: string, isMultipleContact: any): Observable<Array<string>> {
    try {
      return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getContactTypes`,
      [{ Key: 'sessionParameterString', Value: parameterModel },
      { Key: 'moduleName', Value: moduleName },
      { Key: 'isMultipleContact', Value: isMultipleContact }]),
      { headers: this.headers})
        .pipe(map((result) => result as Array<string>));

    } catch (e) {
      console.log(e);
      return null;
    }
  }

  getGenderList() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getGenderList`));
  }

  getEthnicityValues() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getEthnicityValues`));
  }

  getSalutationList() {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getSalutations`));
  }

  getPreferredChannel(): Observable<StringKeyValue[]> {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}getPrefferedChannel`)).pipe(map(res => res as StringKeyValue[]));
  }

  getContactInfo(contactSeqNmbr: number) {
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}GetContactByContactSeqNbr`,
    [{ Key: 'contactSeqNbr', Value: contactSeqNmbr.toString() }]));
  }

  saveContactDataToSession(contact: ContactModel, moduleName: string): Observable<string> {
    return this.http.post<any>(this.apiRef.getApiUrl(`${this.apiServer}SaveContactDataToSession`, [{ Key: 'Module', Value: moduleName }])
      , { headers: this.headers, body: contact })
      .pipe(map(resp => resp.message.toString()));
  }

  removeContactDataFromSession(moduleName: string, index: number) {
    const headers = { 'content-type': 'application/json' };
    return this.http.post(this.apiRef.getApiUrl(`${this.apiServer}RemoveContactDataFromSession`, [
      { Key: 'Module', Value: moduleName },
      { Key: 'index', Value: index.toString() }
    ]), { headers });
  }

  CreateContactParametersSession(paramterModel: string, moduleName: string, processType: string, contactIndex: number = 0) {
    const headers = { 'content-type': 'application/json' };
    return this.http.post(this.apiRef
      .getApiUrl(`${this.apiServer}CreateContactParametersSession`,
        [{ Key: 'moduleName', Value: moduleName },
        { Key: 'processType', Value: processType },
        { Key:'contactIndex', Value: contactIndex.toString()}])
      , paramterModel, { headers });
  }

  getContactModel(parameterModel: string, moduleName: string): Observable<ContactModel> {
    const headers = { 'content-type': 'application/json' };
    return this.http.get(this.apiRef
      .getApiUrl(`${this.apiServer}GetContactModelFromSession`, [
        { Key: 'sessionParameterString', Value: parameterModel },
        { Key: 'moduleName', Value: moduleName }
      ]), { headers: this.headers })
      .pipe(map((result) => result as ContactModel));
  }

  getContactListFromSession(parameterModel: string, moduleName: string): Observable<ContactModel[]> {
    const headers = { 'content-type': 'application/json' };
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}GetContactListFromSession`, [
      { Key: 'sessionParameterString', Value: parameterModel },
      { Key: 'moduleName', Value: moduleName }]),
      { headers: this.headers })
      .pipe(map((result) => result as ContactModel[]));
  }

  validateContactAddress(Contact: ContactModel, moduleName: string) {
    const headers = { 'content-type': 'application/json' };

    return this.http.post<any>(this.apiRef.getApiUrl(`${this.apiServer}ValidateContactAddress`,
    [{ Key: 'moduleName', Value: moduleName }]),
    { headers: this.headers, body: Contact })
      .pipe(map(resp => resp.message.toString()));
  }

  getContactsFromAccount(moduleName: string): Observable<ContactModel[]> {
    const headers = { 'content-type': 'application/json' };
    return this.http.get(this.apiRef.getApiUrl(`${this.apiServer}GetContactsFromAccount`, [{ Key: 'moduleName', Value: moduleName }]),
      { headers: this.headers })
      .pipe(map((result) => result as ContactModel[]));
  }

  saveContactListToSession(ContactList: ContactModel[], ModuleName: string): Observable<string> {
    return this.http.post<any>(this.apiRef.getApiUrl(`${this.apiServer}SaveContactListToSession`,
    [{ Key: 'moduleName', Value: ModuleName }]),
    { headers: this.headers, body: ContactList })
      .pipe(map(resp => resp.message.toString()));
  }
}
